import apiClient from "../core/apiClient";
import { AuthResponseDTO } from "../interfaces/DTO/auth";
import { User } from "../interfaces/DTO/user";
import { useAuthStore } from "../stores/authStore";

class AuthService {
  /**
   * שליפת פרטי המשתמש המחובר ושמירתם ב-Store
   * @returns פרטי ה-JWT של המשתמש המחובר
   */
  async fetchAuthenticatedUser(): Promise<AuthResponseDTO> {
    try {
      // קריאה לשרת לקבלת פרטי המשתמש
      const { data } = await apiClient.get<AuthResponseDTO>("/auth/user");

      // עדכון ה-Store עם פרטי המשתמש
      const setAuthenticated = useAuthStore.getState().setAuthenticated;
      setAuthenticated(true,  data.user, data.auth);

      return data;
    } catch (error) {
      console.error("Failed to fetch authenticated user:", error);

      // ניקוי ה-Store במקרה של כישלון
      const clearAuth = useAuthStore.getState().clearAuth;
      clearAuth();

      throw error; // זריקת השגיאה
    }
  }
   /**
   * התחזות לחברה (Impersonate Company)
   * @param companyId מזהה החברה
   */
  async impersonateCompany(companyId: number): Promise<AuthResponseDTO> {
    try {
      const { data } = await apiClient.post<AuthResponseDTO>("/auth/impersonate-company", null, {
        params: { company_id: companyId },
      });
      useAuthStore.getState().setAuthenticated(true, data.user, data.auth);
      return data;
    } catch (error) {
      console.error("Failed to impersonate company:", error);
      throw error;
    }
  }

  /**
   * התחזות למשתמש (Impersonate User)
   * @param userId מזהה המשתמש
   * @param companyId מזהה החברה של המשתמש
   */
  async impersonateUser(userId: number, companyId: number): Promise<AuthResponseDTO> {
    try {
      const { data } = await apiClient.post<AuthResponseDTO>("/auth/impersonate-user", null, {
        params: { user_id: userId, company_id: companyId },
      });
      useAuthStore.getState().setAuthenticated(true, data.user, data.auth);
      return data;
    } catch (error) {
      console.error("Failed to impersonate user:", error);
      throw error;
    }
  }

  async stopImpersonating(): Promise<AuthResponseDTO> {
    const { data } = await apiClient.post<AuthResponseDTO>("/auth/impersonate/stop");
    useAuthStore.getState().setAuthenticated(true, data.user, data.auth);
    return data;
  }

}

export const authService = new AuthService();
